export enum ImportStatus {
  Untreated = 0,
  ToDo = 10,
  Doing = 20,
  Done = 30,
  Failed = 40,
}

export enum AuthURL {
  TST = 'https://tst-auth.mayohr.com/HRM',
  UAT = 'https://uat-auth.mayohr.com/HRM',
  PRE = 'https://pre-auth.mayohr.com/HRM',
  PRD = 'https://auth.mayohr.com/HRM',
}

export enum WebURL {
  TST = 'https://tst-apolloxe.mayohr.com',
  UAT = 'https://uat-apolloxe.mayohr.com',
  PRE = 'https://pre-hrm-frontend.mayohr.com',
  PRD = 'https://apolloxe.mayohr.com',
}
